const leistungsbereiche = [
  { icon: 'ri-settings-3-line', label: 'Sondermaschinenbau' },
  { icon: 'ri-cpu-line', label: 'Steuerungstechnik & SPS' },
  { icon: 'ri-robot-line', label: 'Automation & Handling' },
  { icon: 'ri-eye-line', label: 'Bildverarbeitung' },
  { icon: 'ri-tools-line', label: 'Mechanische Fertigung' },
  { icon: 'ri-code-s-slash-line', label: 'Hard- & Software' },
  { icon: 'ri-focus-3-line', label: 'Lasertechnik' },
];

const openingHours = [
  { day: 'Montag', hours: '07:30 – 17:00 Uhr' },
  { day: 'Dienstag', hours: '07:30 – 17:00 Uhr' },
  { day: 'Mittwoch', hours: '07:30 – 17:00 Uhr' },
  { day: 'Donnerstag', hours: '07:30 – 17:00 Uhr' },
  { day: 'Freitag', hours: '07:30 – 15:00 Uhr' },
  { day: 'Samstag', hours: 'Geschlossen' },
  { day: 'Sonntag', hours: 'Geschlossen' },
];

const getTodayIndex = () => {
  const day = new Date().getDay();
  return day === 0 ? 6 : day - 1;
};

const ContactInfo = () => {
  const todayIndex = getTodayIndex();

  return (
    <div className="flex flex-col gap-8">
      {/* Adresse & Kontakt */}
      <div className="bg-white border border-gray-100 rounded-xl p-6 md:p-8">
        <h2 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-3">
          <span className="w-8 h-8 flex items-center justify-center bg-[#1E3A8A]/10 rounded-lg">
            <i className="ri-building-2-line text-[#1E3A8A] text-lg"></i>
          </span>
          Kontaktdaten
        </h2>
        <ul className="flex flex-col gap-5">
          <li className="flex items-start gap-4">
            <span className="w-10 h-10 flex items-center justify-center bg-gray-50 rounded-lg shrink-0 mt-0.5">
              <i className="ri-map-pin-line text-[#1E3A8A] text-lg"></i>
            </span>
            <div>
              <p className="text-xs text-gray-400 font-medium uppercase tracking-wide mb-1">Adresse</p>
              <address className="not-italic text-gray-700 text-sm leading-relaxed">
                <strong className="text-gray-900 font-semibold">gowiTEC</strong><br />
                Gewerbeparkstr. 8<br />
                51580 Reichshof-Wehnrath<br />
                Deutschland
              </address>
            </div>
          </li>
          <li className="flex items-start gap-4">
            <span className="w-10 h-10 flex items-center justify-center bg-gray-50 rounded-lg shrink-0">
              <i className="ri-phone-line text-[#1E3A8A] text-lg"></i>
            </span>
            <div>
              <p className="text-xs text-gray-400 font-medium uppercase tracking-wide mb-1">Telefon</p>
              <a
                href="tel:+491776512122"
                className="text-gray-700 text-sm hover:text-[#1E3A8A] transition-colors cursor-pointer font-medium"
              >
                +49 1776512122
              </a>
            </div>
          </li>
          <li className="flex items-start gap-4">
            <span className="w-10 h-10 flex items-center justify-center bg-gray-50 rounded-lg shrink-0">
              <i className="ri-mail-line text-[#1E3A8A] text-lg"></i>
            </span>
            <div>
              <p className="text-xs text-gray-400 font-medium uppercase tracking-wide mb-1">E-Mail</p>
              <a
                href="mailto:anfrage@gowitec.de"
                className="text-gray-700 text-sm hover:text-[#1E3A8A] transition-colors cursor-pointer font-medium break-all"
              >
                anfrage@gowitec.de
              </a>
            </div>
          </li>
        </ul>
      </div>

      {/* Leistungsbereiche */}
      <div className="bg-white border border-gray-100 rounded-xl p-6 md:p-8">
        <h2 className="text-xl font-bold text-gray-900 mb-5 flex items-center gap-3">
          <span className="w-8 h-8 flex items-center justify-center bg-[#1E3A8A]/10 rounded-lg">
            <i className="ri-list-check-2 text-[#1E3A8A] text-lg"></i>
          </span>
          Wir helfen bei
        </h2>
        <div className="flex flex-wrap gap-2">
          {leistungsbereiche.map((l) => (
            <span
              key={l.label}
              className="inline-flex items-center gap-1.5 bg-[#F8FAFC] border border-gray-100 text-gray-700 text-xs font-medium px-3 py-1.5 rounded-full"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className={`${l.icon} text-[#1E3A8A]`}></i>
              </span>
              {l.label}
            </span>
          ))}
        </div>
        <p className="text-xs text-gray-400 mt-4 leading-relaxed">
          Für detaillierte Projektanfragen nutzen Sie bitte unser{' '}
          <a href="/anfrage" className="text-[#1E3A8A] hover:underline font-medium">Anfrage-Formular</a>.
        </p>
      </div>

      {/* Öffnungszeiten */}
      <div className="bg-white border border-gray-100 rounded-xl p-6 md:p-8">
        <h2 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-3">
          <span className="w-8 h-8 flex items-center justify-center bg-[#1E3A8A]/10 rounded-lg">
            <i className="ri-time-line text-[#1E3A8A] text-lg"></i>
          </span>
          Öffnungszeiten
        </h2>
        <ul className="flex flex-col gap-2">
          {openingHours.map((item, index) => {
            const isToday = index === todayIndex;
            const isClosed = item.hours === 'Geschlossen';
            return (
              <li
                key={item.day}
                className={`flex items-center justify-between py-2.5 px-3 rounded-lg transition-colors ${
                  isToday ? 'bg-[#1E3A8A]/5 border border-[#1E3A8A]/20' : 'hover:bg-gray-50'
                }`}
              >
                <span className={`text-sm font-medium ${isToday ? 'text-[#1E3A8A]' : 'text-gray-700'}`}>
                  {item.day}
                  {isToday && (
                    <span className="ml-2 text-xs bg-[#1E3A8A] text-white px-2 py-0.5 rounded-full font-normal">
                      Heute
                    </span>
                  )}
                </span>
                <span className={`text-sm ${isClosed ? 'text-gray-400' : isToday ? 'text-[#1E3A8A] font-semibold' : 'text-gray-600'}`}>
                  {item.hours}
                </span>
              </li>
            );
          })}
        </ul>
        <p className="text-xs text-gray-400 mt-4 leading-relaxed">
          Außerhalb der Öffnungszeiten erreichen Sie uns per E-Mail. Wir melden uns schnellstmöglich zurück.
        </p>
      </div>
    </div>
  );
};

export default ContactInfo;
